import { render } from "./QuestionGroupDetails.vue?vue&type=template&id=01c8906e&scoped=true"
import script from "./QuestionGroupDetails.vue?vue&type=script&lang=js"
export * from "./QuestionGroupDetails.vue?vue&type=script&lang=js"

import "./QuestionGroupDetails.vue?vue&type=style&index=0&id=01c8906e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c8906e"]])

export default __exports__